import timing from 'timing.js';
import ttiPolyfill from 'tti-polyfill';
import { makeSegmentTrackCall } from './analytics';

export async function sendTimingEvents() {
  const tti = await ttiPolyfill.getFirstConsistentlyInteractive();
  const times = timing.getTimes();

  const timesFormatted = Object.keys(times).reduce(
    (acc, key) => ({
      ...acc,
      [`timing${key[0].toUpperCase()}${key.slice(1)}`]: times[key]
    }),
    {}
  );

  makeSegmentTrackCall('Timing', {
    timingTimeToInteractive: tti,
    ...timesFormatted,
    path: window.location.pathname,
    url: window.location.href
  });
}
